export default {
  navHeight: '83px'
}



// WEBPACK FOOTER //
// ./src/constants/sizes.js